<div class='mobile-phone'>
   <div class='brove'><span class='speaker'></span></div>
   <div class='screen'>
      <div class='screen__top' [ngStyle]="{'background': f['PrimaryColor'].value}">
         <div class='screen__top--avatar'></div>
      </div>
      <div class='screen__category-name' [ngStyle]="{'background': f['SecondaryColor'].value}"></div>
      <div class='screen__product'></div>
      <div class='screen__product'></div>
      <div class='screen__category-name' [ngStyle]="{'background': f['SecondaryColor'].value}"></div>
      <div class='screen__product'></div>
      <div class='screen__button' [ngStyle]="{'background': f['PrimaryColor'].value}">
         <div class='screen__button--text' [ngStyle]="{'color': f['TextColor'].value}">{{'ButtonText' | translate}}</div>
      </div>
   </div>
</div>
